import { MapPin, Phone, Bike, ExternalLink } from "lucide-react";
import { useLanguage } from "../i18n";
import { CONTACTS } from "../data/menu";
import { Reveal } from "./Reveal";

export const Contact = () => {
  const { t } = useLanguage();
  return (
    <section id="contatti" data-testid="contact-section" className="bg-surface scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-terra" data-testid="contacts-kicker">{t("contacts_kicker")}</p>
            <h2 className="font-serif text-4xl md:text-6xl text-ink mt-4" data-testid="contacts-title">{t("contacts_title")}</h2>

            <div className="mt-12 space-y-8">
              <div>
                <p className="text-xs tracking-[0.25em] uppercase text-muted2 mb-2">{t("contacts_phone_label")}</p>
                <a href={CONTACTS.phoneHref} data-testid="contact-phone-link" className="font-serif text-3xl md:text-4xl text-ink hover:text-terra transition-colors duration-300">
                  {CONTACTS.phone}
                </a>
                <p className="text-sm text-muted2 mt-1 font-light">{t("contacts_call")}</p>
              </div>
              <div>
                <p className="text-xs tracking-[0.25em] uppercase text-muted2 mb-2">{t("contacts_address_label")}</p>
                <p className="flex items-center gap-3 text-ink text-lg" data-testid="contact-address">
                  <MapPin size={18} className="text-terra shrink-0" /> {CONTACTS.address}
                </p>
                <a
                  href={CONTACTS.mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-directions-link"
                  className="mt-3 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-terra hover:gap-3 transition-all duration-300"
                >
                  {t("contacts_route")} <ExternalLink size={13} />
                </a>
              </div>
              <div className="flex items-center gap-3 rounded-xl border border-terra/30 bg-terra/5 px-5 py-4 w-fit" data-testid="contact-delivery-badge">
                <Bike size={18} className="text-terra" />
                <span className="text-sm tracking-[0.12em] uppercase text-ink">{t("contacts_delivery")}</span>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-xl border border-line h-[320px] lg:h-full min-h-[320px]">
              <iframe
                title="Mappa Da Polin"
                data-testid="contact-map"
                src={CONTACTS.mapsEmbed}
                className="h-full w-full grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
